import * as React from 'react';
import { observer } from 'mobx-react';
import { SvgIcon } from '../../../WebGiving/components/svg-icon';
import { Text } from '../../../WebGiving/components/text';
import warningIcon from '../../assets/svg/warning-icon.svg';

import { container, icon, iconMultiLine, content } from './warning.less';

@observer
export class Warning extends React.Component<{ content: React.ReactChild | null | undefined, id?: string, multipleLines?: boolean }> {

	render() {
		const { content: warningContent, id, multipleLines } = this.props;
		const isString = typeof warningContent === 'string';
		return warningContent ? (
			<div className={container} data-warning id={id}>
				<SvgIcon svg={warningIcon} className={multipleLines ? iconMultiLine : icon} />
				<div className={content}>
					{isString ? <Text>{warningContent as string}</Text> : warningContent}
				</div>
			</div>
		) : null;
	}
}
